import { isProduction } from 'src/utils/env';

export const getWebFlowBasePathByEnv = (productionPath='content', devPath='contents') => {
  const productionEnv = isProduction();
  const basePath = productionEnv ? productionPath : devPath;
  return `https://${basePath}.hellotech.com`;
};
